import { render, staticRenderFns } from "./add-modal.vue?vue&type=template&id=0a28e7ef&scoped=true"
import script from "./add-modal.vue?vue&type=script&lang=js"
export * from "./add-modal.vue?vue&type=script&lang=js"
import style0 from "./add-modal.vue?vue&type=style&index=0&id=0a28e7ef&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a28e7ef",
  null
  
)

export default component.exports